import React from 'react'
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom'
import { MenuUnificadoDay } from '../menu/MenuUnificadoDay'
import { MenuUnificadoDayOnline } from '../menu/MenuUnificadoDayOnline'

export const MenuUnificadoRouterDay = () => {

  const basename = document.querySelector('base')?.getAttribute('href') ?? '/'  

  return (
    <BrowserRouter basename={basename}>
        <Routes>
            <Route path="/*" element={<MenuUnificadoDayOnline />} />
            <Route path="/vermenuonline" element={<MenuUnificadoDay />} />  
        </Routes>
    </BrowserRouter>
  )
}
